import React, { useState } from "react";
import "./Switch.css";

const Switch = ({ setStream, switchLeft, switchRight }) => {
  const [active, setActive] = useState(switchLeft);

  const handleSwitch = (value) => {
    setActive(value);
    setStream(value);
  };

  return (
    <div className="switch-responsive-container">
      <div className="switch-track">
        <button
          className={`switch-option ${active === switchLeft ? 'active' : ''}`}
          onClick={() => handleSwitch(switchLeft)}
          aria-label={`Select ${switchLeft}`}
        >
          {switchLeft}
        </button>
        <button
          className={`switch-option ${active === switchRight ? 'active' : ''}`}
          onClick={() => handleSwitch(switchRight)}
          aria-label={`Select ${switchRight}`}
        >
          {switchRight}
        </button>
        <span className={`switch-thumb ${active === switchRight ? 'right' : ''}`} aria-hidden="true"></span>
      </div>
    </div>
  );
};

export default Switch;